module.exports = __webpack_public_path__ + "static/macbook_mockup-199e2a6f4a3f56a1e34ce66ac8d2b50c.png";